import type { TrackingData } from "./types/tracking";
import { tracking } from "./tracking";
import { GlobalStorage } from "@otto-ec/global-resources";
import { isCookieBannerEnabled } from "./helper";
import { trackEmptyState } from "./tracking/EmptyState";
import { trackSessionStart } from "./tracking/SessionStart";
import { trackSuggestRenderTime } from "./tracking/Suggest";

/*🤫
🤫
🤫
🤫*/

function updateSearchType(
  currentSearchType: string,
  isModifiedSearch: boolean,
  isTrackSuggest: boolean,
  isEmptyState: boolean,
  isHistorySuggest: boolean
): string {
  let searchType: string = currentSearchType || "";
  if (isModifiedSearch) {
    searchType = "modified";
  }
  if (isTrackSuggest) {
    if (isEmptyState) {
      searchType = "empty_state";
    } else {
      searchType = "suggest";
    }
  }
  if (isHistorySuggest) {
    searchType = "history";
  }
  return searchType;
}

function trackUsage(
  extendByParameters: TrackingData,
  extendByHashParameters: TrackingData,
  isModifiedSearch: boolean,
  isTrackSuggest: boolean,
  isEmptyState: boolean,
  isHistorySuggest: boolean
) {
  let storage: GlobalStorage;

  const jsonForTracking: TrackingData = {};
  Object.keys(extendByParameters).forEach((key: string) => {
    jsonForTracking[key] = extendByParameters[key];
  });

  jsonForTracking["wk.san_SearchType"] = updateSearchType(
    jsonForTracking["wk.san_SearchType"] as string,
    isModifiedSearch,
    isTrackSuggest,
    isEmptyState,
    isHistorySuggest
  );

  if (isCookieBannerEnabled()) {
    jsonForTracking["wk.san_InitialSearchBoxTime"] = trackSessionStart.updateLabel();
  }

  /*🤫*/
  if (isEmptyState) {
    jsonForTracking["wk.san_EmptyStateTime"] = trackEmptyState.getTotalTime();
    jsonForTracking["wk.san_EmptyStateCount"] = trackEmptyState.getCount();
  }

  jsonForTracking["san_SuggestRenderTime"] = trackSuggestRenderTime.getTime();

  if (isEmptyState && !window.o_squirrel.submitHistory.isEmpty()) {
    /*🤫*/
    extendByHashParameters.san_SuggestList = extendByHashParameters.san_SuggestList?.split("|").slice(0, 5).join("|");
    extendByHashParameters.san_SuggestListWordCount = extendByHashParameters.san_SuggestListWordCount
      ?.split("|")
      .slice(0, 5)
      .join("|");
  }

  const trackingData: TrackingData = mergeTrackingLabels(extendByHashParameters, jsonForTracking);

  if (tracking.isInitialized()) {
    tracking.sendTrackingDataForNextPI(trackingData);
  } else {
    storage = new window.o_global.Storage(() => window.sessionStorage);
    if (storage.isAvailable) {
      jsonForTracking["san_PageLoadComplete"] = "false";
      try {
        storage.setItem("squirrel_searchTracking", JSON.stringify(jsonForTracking));
      } catch (e) {
        throw e as Error;
      }
    }
  }
}

export function mergeTrackingLabels(trackingData1: TrackingData, trackingData2: TrackingData): TrackingData {
  Object.keys(trackingData2).forEach((key: string) => {
    trackingData1[key] = trackingData2[key];
  });
  return trackingData1;
}

/*🤫
🤫
🤫
🤫
🤫
🤫*/
function markFormForTracking(marker: string, searchForm: HTMLFormElement) {
  searchForm.classList.add(marker);
}

/*🤫
🤫
🤫
🤫
🤫
🤫*/
function unmarkFormForTracking(marker: string, searchForm: HTMLFormElement) {
  searchForm.classList.remove(marker);
}

export const suggestTracking = {
  unmarkFormForTracking,
  markFormForTracking,
  trackUsage,

  /*🤫*/
  mergeTrackingLabels,
};
